<div class="servicer-list">
  <dx-load-panel [visible]="isLoading"
                 shadingColor="rgba(0,0,0,0.4)"
                 [showIndicator]="true"
                 [showPane]="true"
                 message="Loading..."></dx-load-panel>

  <dx-data-grid [dataSource]="servicers"
                [columns]="dataGridOptions.columns"
                [paging]="dataGridOptions.paging"
                [searchPanel]="dataGridOptions.searchPanel"
                [filterRow]="dataGridOptions.filterRow"
                [headerFilter]="dataGridOptions.headerFilter"
                [columnAutoWidth]="dataGridOptions.columnAutoWidth"
                [allowColumnReordering]="dataGridOptions.allowColumnReordering"
                [allowColumnResizing]="dataGridOptions.allowColumnResizing"
                [showBorders]="dataGridOptions.showBorders"
                [rowAlternationEnabled]="dataGridOptions.rowAlternationEnabled"
                width="100%">
  </dx-data-grid>
</div>
